export default "__VITE_ASSET__DRY83WKI__"